
  <div class="password_wrap">
    <div class="pass">
      <h1>请输入密码</h1>
      <input v-model="password" class="pass_input" placeholder="请输入密码" />
      <div class="true_btn" @click="handleTrueClick">确定</div>
    </div>
  </div>
